<template>
  <header-block name="Pages"></header-block>
  <aside-block active="editor" />
  <div class="container mt-3">
    <div class="white-box">
      <div class="row mb-2">
        <div class="col">
          <h1>Page editor</h1>
        </div>
        <div class="col-auto">
          <select class="form-control" v-model="selectedWebshop">
            <option :value="null">All webshop</option>
            <option
              v-for="webshop in webshops"
              :key="webshop.id"
              :value="webshop.id"
            >
              {{ webshop.name }}
            </option>
          </select>
        </div>
        <div class="col-auto">
          <button class="btn btn-primary" v-on:click="showAddPage">
            Add page
          </button>
        </div>
      </div>
      <div class="item-list mx-2">
        <div class="item row" v-for="page in fiteredPages" :key="page.id">
          <div class="col-auto">
            <div class="circle bg-green" v-if="page.is_active"></div>
            <div class="circle bg-red" v-else></div>
          </div>
          <router-link :to="'/editor/' + page.id" class="row col">
            <div class="col-4">{{ page.name }}</div>
            <div class="col-4 menu-url">/{{ page.slug }}</div>
            <div class="col-4" v-if="page.webshop_id && webshops.length > 1">
              {{ webshops.find((e) => e.id === page.webshop_id)?.name }}
            </div>
            <div
              class="col-4"
              v-else-if="!page.webshop_id && webshops.length > 1"
            >
              All webshop
            </div>
          </router-link>
          <div class="col-auto">
            <button
              class="btn btn-transparent"
              v-if="page.is_active"
              v-on:click="setActive(page, false)"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path
                  d="M17.8827 19.2968C16.1814 20.3755 14.1638 21.0002 12.0003 21.0002C6.60812 21.0002 2.12215 17.1204 1.18164 12.0002C1.61832 9.62282 2.81932 7.5129 4.52047 5.93457L1.39366 2.80777L2.80788 1.39355L22.6069 21.1925L21.1927 22.6068L17.8827 19.2968ZM5.9356 7.3497C4.60673 8.56015 3.6378 10.1672 3.22278 12.0002C4.14022 16.0521 7.7646 19.0002 12.0003 19.0002C13.5997 19.0002 15.112 18.5798 16.4243 17.8384L14.396 15.8101C13.7023 16.2472 12.8808 16.5002 12.0003 16.5002C9.51498 16.5002 7.50026 14.4854 7.50026 12.0002C7.50026 11.1196 7.75317 10.2981 8.19031 9.60442L5.9356 7.3497ZM12.9139 14.328L9.67246 11.0866C9.5613 11.3696 9.50026 11.6777 9.50026 12.0002C9.50026 13.3809 10.6196 14.5002 12.0003 14.5002C12.3227 14.5002 12.6309 14.4391 12.9139 14.328ZM20.8068 16.5925L19.376 15.1617C20.0319 14.2268 20.5154 13.1586 20.7777 12.0002C19.8603 7.94818 16.2359 5.00016 12.0003 5.00016C11.1544 5.00016 10.3329 5.11773 9.55249 5.33818L7.97446 3.76015C9.22127 3.26959 10.5793 3.00016 12.0003 3.00016C17.3924 3.00016 21.8784 6.87992 22.8189 12.0002C22.5067 13.6998 21.8038 15.2628 20.8068 16.5925ZM11.7229 7.50857C11.8146 7.50299 11.9071 7.50016 12.0003 7.50016C14.4855 7.50016 16.5003 9.51488 16.5003 12.0002C16.5003 12.0933 16.4974 12.1858 16.4919 12.2775L11.7229 7.50857Z"
                ></path>
              </svg>
            </button>
            <button
              class="btn btn-transparent"
              v-else
              v-on:click="setActive(page, true)"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path
                  d="M12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3ZM12.0003 19C16.2359 19 19.8603 16.052 20.7777 12C19.8603 7.94803 16.2359 5 12.0003 5C7.7646 5 4.14022 7.94803 3.22278 12C4.14022 16.052 7.7646 19 12.0003 19ZM12.0003 16.5C9.51498 16.5 7.50026 14.4853 7.50026 12C7.50026 9.51472 9.51498 7.5 12.0003 7.5C14.4855 7.5 16.5003 9.51472 16.5003 12C16.5003 14.4853 14.4855 16.5 12.0003 16.5ZM12.0003 14.5C13.381 14.5 14.5003 13.3807 14.5003 12C14.5003 10.6193 13.381 9.5 12.0003 9.5C10.6196 9.5 9.50026 10.6193 9.50026 12C9.50026 13.3807 10.6196 14.5 12.0003 14.5Z"
                ></path>
              </svg>
            </button>
            <button class="btn btn-transparent" v-on:click="showEditPage(page)">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
              >
                <path
                  d="M2 12c0-.865.11-1.703.316-2.504A3 3 0 0 0 4.99 4.867a9.99 9.99 0 0 1 4.335-2.505 3 3 0 0 0 5.348 0 9.99 9.99 0 0 1 4.335 2.505 3 3 0 0 0 2.675 4.63c.206.8.316 1.638.316 2.503 0 .865-.11 1.703-.316 2.504a3 3 0 0 0-2.675 4.629 9.99 9.99 0 0 1-4.335 2.505 3 3 0 0 0-5.348 0 9.99 9.99 0 0 1-4.335-2.505 3 3 0 0 0-2.675-4.63C2.11 13.704 2 12.866 2 12zm4.804 3c.63 1.091.81 2.346.564 3.524.408.29.842.541 1.297.75A4.993 4.993 0 0 1 12 18c1.26 0 2.438.471 3.335 1.274.455-.209.889-.46 1.297-.75A4.993 4.993 0 0 1 17.196 15a4.993 4.993 0 0 1 2.77-2.25 8.126 8.126 0 0 0 0-1.5A4.993 4.993 0 0 1 17.195 9a4.993 4.993 0 0 1-.564-3.524 7.989 7.989 0 0 0-1.297-.75A4.993 4.993 0 0 1 12 6a4.993 4.993 0 0 1-3.335-1.274 7.99 7.99 0 0 0-1.297.75A4.993 4.993 0 0 1 6.804 9a4.993 4.993 0 0 1-2.77 2.25 8.126 8.126 0 0 0 0 1.5A4.993 4.993 0 0 1 6.805 15zM12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <AddPage
    v-model:show="addPageShow"
    v-model:page="selectedPage"
    v-model:webshops="webshops"
    v-on:add="addPage"
    v-on:edit="editPage"
  />
</template>
<script>
import HeaderBlock from "../components/header";
import AsideBlock from "../components/asideBlock";
import http from "../modules/http";
import AddPage from "../components/modals/AddPage";
export default {
  name: "PageList",
  components: { AddPage, AsideBlock, HeaderBlock },
  data() {
    return {
      pages: [],
      webshops: [],
      selectedWebshop: null,
      addPageShow: false,
      selectedPage: null,
    };
  },
  computed: {
    fiteredPages() {
      if (this.selectedWebshop === null) {
        return this.pages;
      }
      return this.pages.filter(
        (e) => e.webshop_id === null || e.webshop_id === this.selectedWebshop
      );
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      if (this.webshops.length === 0) {
        http.fetch("/webshops").then((data) => {
          this.webshops = data;
        });
      }
      http.fetch("/page").then((data) => {
        this.pages = data.data;
      });
    },
    showAddPage() {
      this.selectedPage = null;
      this.addPageShow = true;
    },
    addPage(page) {
      http.fetch("/page", page).then((data) => {
        this.pages.push(data.data);
      });
    },
    showEditPage(page) {
      http.fetch("/page/" + page.id).then((data) => {
        this.selectedPage = data.data;
        this.addPageShow = true;
      });
    },
    setActive(page, status) {
      http
        .fetch("/page/" + page.id+"/status", {
          is_active: status ? 1 : 0,
        })
        .then(() => {
          page.is_active = status;
        });
    },
    editPage(page) {
      http.fetch("/page/" + page.id, page);
    },
  },
};
</script>
